import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Image } from '@ks89/angular-modal-gallery';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { ProductsService } from 'src/app/shared/service/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import * as Notiflix from 'notiflix';
import { HttpEventType } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
  providers: [NgbRatingConfig]
})
export class ProductDetailComponent implements OnInit {
  getProgressBarType(progress: number): string {
    if (progress < 50) {
      return 'danger'; // Rojo si es menor de 50%
    } else if (progress >= 50 && progress < 80) {
      return 'warning'; // Amarillo entre 50% y 80%
    } else {
      return 'success'; // Verde si es mayor de 80%
    }
  }
  
  handleImageError(event: any) {
    console.warn('❌ Error al cargar imagen del curso, usando placeholder');
    event.target.src = 'assets/images/placeholder.png';
  }
  
  // Método para obtener la imagen del curso (frontImage.base64 o ImgFileUrl)
  getCourseImage(): string {
    if (this.productInfo?.frontImage?.base64) {
      const mimetype = this.productInfo.frontImage.mimetype || 'image/jpeg';
      const base64Image = `data:${mimetype};base64,${this.productInfo.frontImage.base64}`;
      console.log('🖼️ Usando frontImage.base64 del curso ID:', this.productInfo.id);
      return base64Image;
    }
    
    if (this.productInfo?.ImgFileUrl) {
      console.log('🖼️ Usando ImgFileUrl del curso');
      return this.productInfo.ImgFileUrl;
    }
    
    console.warn('⚠️ No hay imagen disponible para el curso ID:', this.productInfo?.id);
    return ''; // Retornar string vacío en lugar de placeholder
  }
  
  productInfo: any;
  archivoUrl: SafeResourceUrl | null = null;
  isAdmin: boolean = false;

  constructor(
    private route: Router,
    private productService: ProductsService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) { }

  verArchivoMicrosoft(url: string): void {
    const fullUrl = `http://docs.google.com/gview?url=${url}&embedded=true`;
    console.log("Mostrando archivo en:", fullUrl);
    // Sanitiza la URL antes de asignarla al iframe
    window.open(fullUrl, '_blank');
  } 

  updateVideo(event: any, topic: any, moduloNumero: number, leccionNumero: number) {
    const file = event.target.files[0];
    if (file) {
      topic.uploading = true; // Indicar que la subida ha comenzado
      const formData = new FormData();
      formData.append('name', `Modulo ${moduloNumero}, Lección ${leccionNumero}`);
      formData.append('type', 'videos');
      formData.append('videoupload', file);
  
      this.productService.uploadVideoModulo(formData).subscribe(
        (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            // Calcula el porcentaje del progreso
            const percentDone = Math.round((100 * event.loaded) / (event.total || 1));
            console.log(`Progreso: ${percentDone}%`);
            topic.progress = percentDone; // Actualiza el progreso en el objeto
          } else if (event.type === HttpEventType.Response) {
            // Video subido con éxito
            topic.uploaded = true; // Indicar que el video ha sido subido
            topic.uploading = false; // Finalizar estado de subida
            topic.FileName = file.name; // Guardar el nombre del archivo
            topic.FileSize = this.formatFileSize(file.size); // Guardar el tamaño del archivo
            topic.Type = file.type; // Guardar el tipo del archivo
  
            // Crear el objeto para actualizar el tópico
            const newtopic = {
              videoUrl: event.body.videoUrl,
              FileName: topic.FileName,
              FileSize: topic.FileSize, // Agregar el tamaño del archivo
              Type: topic.Type, // Agregar el tipo del archivo
            };
  
            // ✅ Validar que el topic tiene un ID antes de intentar actualizar
            if (topic.id) {
              this.productService.updateTopic(topic.id, newtopic).subscribe({
                next: (data: any) => {
                  Notiflix.Notify.success('Video cargado correctamente');
                  topic.videoUrl = event.body.videoUrl; // Actualizar la URL del video en el tópico
                },
                error: (error) => {
                  console.error('❌ Error al actualizar topic:', error);
                  Notiflix.Notify.failure('Error al actualizar el video');
                }
              });
            } else {
              console.warn('⚠️ No se puede actualizar el topic porque no tiene ID asignado');
            }
          }
        },
        (error) => {
          console.error(`Error al subir el video ${file.name} para el módulo ${moduloNumero}, lección ${leccionNumero}:`, error);
          topic.uploading = false; // Manejo de error
        }
      );
    }
  }
   

  ngOnInit(): void {
    // Verificar si el usuario es admin
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.isAdmin = user.roles === 'admin';
    
    this.loadData();
  }
  
  async loadData() {
    try {
      const id = this.activatedRoute.snapshot.paramMap.get('id');
      
      if (!id) {
        console.error('❌ No se encontró el ID del curso');
        Notiflix.Notify.failure('No se pudo cargar el curso');
        this.route.navigateByUrl('/products/courses');
        return;
      }

      console.log('📥 Cargando curso con ID:', id);
      const query = this.productService.getCourseById(id);
      const response = await lastValueFrom(query);
      
      console.log('✅ Respuesta del servidor:', response);
      
      // Validar que la respuesta tenga la estructura esperada
      if (!response) {
        console.error('❌ Respuesta vacía del servidor');
        Notiflix.Notify.failure('No se pudo cargar el curso');
        this.route.navigateByUrl('/products/courses');
        return;
      }

      // 🔥 NUEVO: Manejar estructura con message y data
      const courseData = response.data || response;
      this.productInfo = courseData;
      
      console.log('📦 Estructura del curso:', {
        id: this.productInfo.id,
        title: this.productInfo.Title,
        hasFrontImage: !!this.productInfo.frontImage,
        frontImageFilename: this.productInfo.frontImage?.filename
      });

      // Procesar la imagen desde frontImage si existe
      if (this.productInfo.frontImage && this.productInfo.frontImage.base64) {
        const mimetype = this.productInfo.frontImage.mimetype || 'image/jpeg';
        this.productInfo.ImgFileUrl = `data:${mimetype};base64,${this.productInfo.frontImage.base64}`;
        console.log('✅ Imagen procesada desde frontImage:', this.productInfo.frontImage.filename);
      } else if (!this.productInfo.ImgFileUrl) {
        console.warn('⚠️ No se encontró imagen en frontImage ni en ImgFileUrl');
      }

      // Validar que productInfo tenga los datos necesarios
      if (!this.productInfo.ProductInfo || !Array.isArray(this.productInfo.ProductInfo)) {
        console.warn('⚠️ ProductInfo no tiene la estructura esperada');
        this.productInfo.ProductInfo = [];
      }

      if (!this.productInfo.product || !Array.isArray(this.productInfo.product)) {
        console.warn('⚠️ product no tiene la estructura esperada');
        this.productInfo.product = [];
      }

      const resources = this.productInfo.ProductInfo.filter((pi: any) => pi.Property === 'Resource');
      
      this.productInfo.product.forEach(element => {
        if (element.Topics && Array.isArray(element.Topics)) {
          element.Topics = element.Topics.map((topic: any) => {
            return {
              ...topic,
              uploading: false,
              vimeoUploading: false,
              Resources: resources.filter((r: any) => r.Commentary === topic.id?.toString())
            }
          });
        } else {
          element.Topics = [];
        }
      });

      console.log('✅ Curso cargado correctamente:', this.productInfo.Title);
    } catch (error: any) {
      console.error('❌ Error al cargar el curso:', error);
      
      if (error.status === 404) {
        Notiflix.Notify.failure('Curso no encontrado');
      } else if (error.status === 403) {
        Notiflix.Notify.failure('No tienes permiso para ver este curso');
      } else if (error.status === 500) {
        Notiflix.Notify.failure('Error del servidor al cargar el curso');
      } else {
        Notiflix.Notify.failure('Error al cargar el curso');
      }
      
      this.route.navigateByUrl('/products/courses');
    }
  }

  setActive() {
    if (!this.productInfo?.id) {
      console.error('❌ No se encontró el ID del curso');
      Notiflix.Notify.failure('No se pudo publicar el curso');
      return;
    }

    // Verificar que el curso no esté ya publicado
    if (this.productInfo.Status?.toLowerCase() === 'publicado') {
      Notiflix.Notify.warning('El curso ya está publicado');
      return;
    }

    Notiflix.Confirm.show(
      'Publicar curso',
      '¿Estás seguro de que deseas publicar este curso? Una vez publicado, estará visible para los usuarios.',
      'Sí, publicar',
      'Cancelar',
      () => {
        console.log('📤 Publicando curso ID:', this.productInfo.id);
        
        this.productService.publishCourse(this.productInfo.id).subscribe({
          next: (response: any) => {
            console.log('✅ Curso publicado exitosamente:', response);
            Notiflix.Notify.success('Curso publicado correctamente');
            
            // Recargar la página o redirigir a la lista
            this.route.navigateByUrl('/products/courses');
          },
          error: (error: any) => {
            console.error('❌ Error al publicar el curso:', error);
            
            if (error.status === 404) {
              Notiflix.Notify.failure('Curso no encontrado');
            } else if (error.status === 403) {
              Notiflix.Notify.failure('No tienes permiso para publicar este curso');
            } else if (error.status === 400) {
              Notiflix.Notify.failure(error.error?.message || 'El curso no cumple con los requisitos para ser publicado');
            } else {
              Notiflix.Notify.failure('Error al publicar el curso');
            }
          }
        });
      },
      () => {
        console.log('❌ Publicación cancelada por el usuario');
      }
    );
  }

  sharedToVimeo(topic: any) {
    topic.vimeoUploading = false;
    const body = {
      name: topic.Title,
      path: topic.videoUrl,
    }

    this.productService.sharedVideo(body).subscribe({
      next: (data: any) => {
        const newtopic = {
          videoUrl: data.videoUrl,
        }
        
        // ✅ Validar que el topic tiene un ID antes de intentar actualizar
        if (topic.id) {
          this.productService.updateTopic(topic.id, newtopic).subscribe({
            next: (data: any) => {
              topic.videoUrl = data.videoUrl;
              topic.vimeoUploading = false;
              Notiflix.Notify.success('Video publicado correctamente');
            },
            error: (error) => {
              console.error('❌ Error al actualizar topic:', error);
              topic.vimeoUploading = false;
              Notiflix.Notify.failure('Error al publicar el video');
            }
          });
        } else {
          console.warn('⚠️ No se puede actualizar el topic porque no tiene ID asignado');
          topic.vimeoUploading = false;
        }
      },
      error: (error) => {
        console.error('❌ Error al compartir video a Vimeo:', error);
        topic.vimeoUploading = false;
        Notiflix.Notify.failure('Error al compartir el video');
      }
    });

  }

  onSelectImages(event) {
    const file = event.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'images');
      this.productService.uploadFile2(formData)
        .subscribe(resolve => {
          if (resolve.FileUrl !== null) {
            const body = {
              id: this.productInfo.id,
              ImgFileUrl: resolve.ImageUrl
            };
            this.productService.updateCourse2(this.productInfo.id, body).subscribe((data: any) => {
              this.productInfo.ImgFileUrl = resolve.ImageUrl;
              Notiflix.Notify.success('Imagen cargada correctamente')
            });
          }
        });
    }
  }

  formatFileSize(size: number): string {
    if (size === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
 
}